import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import UiContentCard from "../../../components/cards/UiContentCard"
import Nike from "../../../../../styles/img/favourites/nike.jpg"
import Tokyo from "../../../../../styles/img/favourites/tokyo.jpg"

import { UiSlider } from "../../../components/common/UiSlider";
import { UiNextArrow, UiPrevArrow } from "../../../components/common/UiSliderArrows.jsx";


export default function MyFavourites(props) {
    const learnMore = () => {
    }
    const UiShopSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5.5,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 768,
                settings: "unslick"

            }]

    };

    return (
        <>
            <div className='sb-shop-slider'>
                <UiSlider UiSliderSettings={UiShopSlider}>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Nike}
                                    rating="4.41"
                                    timeStatus="1 Week Left"
                                    reviews="47"
                                    heading="Nike"
                                    bottomIcon="true"
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                    points="35"
                                    savings="25K"
                                    footer="true"
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Tokyo}
                                    timeStatus="Event Ended"
                                    rating="4.41"
                                    reviews="47"
                                    heading="Tokyo"
                                    bottomIcon="true"
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                    points="35"
                                    savings="25K"
                                    footer="true"
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Nike}
                                    rating="4.41"
                                    timeStatus="1 Week Left"
                                    reviews="47"
                                    heading="Nike"
                                    bottomIcon="true"

                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                    points="35"
                                    savings="25K"
                                    footer="true"
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Tokyo}
                                    timeStatus="Event Ended"
                                    rating="4.41"
                                    reviews="47"
                                    heading="Tokyo"

                                    bottomIcon="true"
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                    points="35"
                                    savings="25K"
                                    footer="true"
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Tokyo}
                                    timeStatus="Event Ended"
                                    rating="4.41"
                                    reviews="47"
                                    heading="Tokyo"

                                    bottomIcon="true"
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                    points="35"
                                    savings="25K"
                                    footer="true"
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Tokyo}
                                    timeStatus="Event Ended"
                                    rating="4.41"
                                    reviews="47"
                                    heading="Tokyo"

                                    bottomIcon="true"
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                    points="35"
                                    savings="25K"
                                    footer="true"
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Tokyo}
                                    timeStatus="Event Ended"
                                    rating="4.41"
                                    reviews="47"
                                    heading="Tokyo"

                                    bottomIcon="true"
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                    points="35"
                                    savings="25K"
                                    footer="true"
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                </UiSlider>
                <div className='sb-shop-slider__fade-out'></div>
            </div>
        </>
    )
}
